import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontMainNav from "../../shared/FrontMainNav/FrontMainNav";


function CGV() {
    return (
        <div className="landing-page-component">
            <FrontHeader />
            <div className="page-content pb-5">
                <FrontMainNav />
                <h1 className="custom-page-title">
                  Politique Générale de Ventes de Coran soigne
                </h1>
                <div className="container pb-4">
                    <div className="custom-politique-page-content pt-5">
                        <div className="content-all-politique pt-4 pb-3">
                            <div className="content-politique-item">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">1. Commandes et Paiements</h3>
                                <div className="custom-sm-value">
                                 <p>1.1. Passer une Commande : Lorsque vous passez une commande sur notre site, vous acceptez d'acheter les produits ou services sélectionnés aux prix et conditions indiqués.</p>
                                     <p>1.2. Paiements : Les paiements sont traités de manière sécurisée via des méthodes de paiement en ligne sécurisées. Les informations de paiement sont cryptées et protégées.</p> 
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">2. Livraison et Frais de Port</h3>
                                <div className="custom-sm-value">
                                    <p>2.1. Livraison : Nous nous engageons à expédier vos commandes dans les délais indiqués sur notre site</p>
                                    <ul className="custom-instruction-list">
                                        <li className="listitem">Dakar : 24 heures</li>
                                        <li className="listitem">Régions du Sénégal : 2 à 5 jours ouvrables</li>
                                        <li className="listitem">International : selon le pays de destination</li>
                                    </ul>
                                    <p>Les délais de livraison peuvent varier en fonction de votre emplacement et du mode d'expédition choisi.</p>
                                    <p>2.2. Frais de Port : Les frais de port sont calculés en fonction du poids, de la taille et de la destination de votre commande. Les frais de port seront indiqués avant la livraison.</p>
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">3. Politique de Retour et de Remboursement</h3>
                                <div className="custom-sm-value">
                                    <p>3.1. Les demandes de retour sont acceptées dans un délai de 7 jours après réception du produit, sous réserve du respect des conditions de retour.</p>
                                    <p>3.2. Remboursements : Le remboursement est effectué dans un délai de 7 à 14 jours ouvrables après validation du retour.</p>
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">4. Garantie</h3>
                                <div className="custom-sm-value">
                                    <p>4.1. Garantie des Produits : Garantie satisfaction de 7 jours sur les produits éligibles conformément à notre politique de retour.</p>
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">5. Responsabilité</h3>
                                <div className="custom-sm-value">
                                    <p>5.1. Limitation de Responsabilité : Nous déclinons toute responsabilité pour tout dommage direct, indirect, spécial, consécutif ou punitif résultant de l'utilisation de nos produits ou services.</p>
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">6. Modifications de la Politique</h3>
                                <div className="custom-sm-value">
                                    <p>6.1. Modifications : Nous nous réservons le droit de modifier cette Politique à tout moment. Les modifications seront effectives dès leur publication sur notre site.</p>
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">7. Contact</h3>
                                <div className="custom-sm-value">
                                    <p>7.1. Contact : Pour toute question concernant notre Politique Générale de Ventes, veuillez nous contacter via les coordonnées fournies sur notre site.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FrontFooter />
        </div>
    );
}

export default CGV;